import Vue from 'vue'
import './plugins/fontawesome'
import Vuex from 'vuex'
import App from './App.vue'
import './registerServiceWorker'
import './app.scss';

Vue.config.productionTip = false;
Vue.use(Vuex);

window.EventBus = new Vue();

const store = new Vuex.Store({
  state: {
    screen: 'game',
    game: 'starting',
    baseScore: 301,
    settings: {
      mustEndOnExactlyZero: false,
      input: 'completeScore'
    }
  }
});

new Vue({
  render: h => h(App),
  store,
}).$mount('#app');
